/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Fields_SummaryInputs */

const cs_templates_fields_summary = /** @type {(inputs: Templates_Fields_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pole šablony`)
};

const en_templates_fields_summary = /** @type {(inputs: Templates_Fields_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template fields`)
};

/**
* | output |
* | --- |
* | "Template fields" |
*
* @param {Templates_Fields_SummaryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_fields_summary = /** @type {((inputs?: Templates_Fields_SummaryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Fields_SummaryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_fields_summary(inputs)
	return cs_templates_fields_summary(inputs)
});